import { SubmissionType, TestFormat, TestFormatV2 } from '~/types/Test'

/**
 * Maps TestFormat to the corresponding string.
 * Eg: `testFormatOptions[TestFormat.Likert]` returns `'Likert'`
 */
export const testFormatOptions: Record<TestFormat, string> = {
  [TestFormat.Likert]: 'Likert',
  [TestFormat.Mcq]: 'MCQ',
  [TestFormat.Written]: 'Written',
  [TestFormat.Simulation]: 'Simulation',
  [TestFormat.SimulationV2]: 'Simulation',
  [TestFormat.Submission]: 'Submission',
}

/**
 * Maps TestFormat to the corresponding icon.
 * Eg: `testFormatIcons[TestFormat.Likert]` returns `'mdi-format-list-numbered'`
 */
export const testFormatIcons: Record<TestFormat, string> = {
  [TestFormat.Likert]: 'fa-regular fa-scale-unbalanced',
  [TestFormat.Mcq]: 'fa-regular fa-list',
  [TestFormat.Written]: 'fa-regular fa-pen',
  [TestFormat.Simulation]: 'fa-regular fa-island-tropical',
  [TestFormat.SimulationV2]: 'fa-regular fa-island-tropical',
  [TestFormat.Submission]: 'fa-regular fa-upload',
  // icons for video and voice formats required
}

export const submissionTestIcons: Record<SubmissionType, string> = {
  [SubmissionType.Document]: 'fa-regular fa-file-arrow-up',
  [SubmissionType.Audio]: 'fa-regular fa-microphone',
  [SubmissionType.Video]: 'fa-regular fa-video',
}

export const testFormatMap = {
  [TestFormat.Likert]: 'Likert',
  [TestFormat.Mcq]: 'MCQ',
  [TestFormat.Written]: 'Written',
  [TestFormat.Simulation]: 'Simulation',
  [TestFormat.SimulationV2]: 'Simulation',
  [TestFormat.Submission]: 'Submission',
}
// [TestFormat.VideoSubmission]: 'Submission',
// [TestFormat.VoiceSubmission]: 'Submission',

// get format v2 from format v1
export const testFormatToV2Map = {
  [TestFormat.Likert]: TestFormatV2.Question,
  [TestFormat.Mcq]: TestFormatV2.Question,
  [TestFormat.Written]: TestFormatV2.Question,
  [TestFormat.Simulation]: TestFormatV2.Simulation,
  [TestFormat.SimulationV2]: TestFormatV2.SimulationV2,
  [TestFormat.Submission]: TestFormatV2.Submission,
}
